'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by lyj on 2016/10/15.
                    */

// import SubmitBtn from '../SubmitBtn/SubmitBtn';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _ProductInfoFirstCarousel = require('../ProductInfoFirstCarousel/ProductInfoFirstCarousel');

var _ProductInfoFirstCarousel2 = _interopRequireDefault(_ProductInfoFirstCarousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DetailBigCarousel = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(DetailBigCarousel, _Component);

  function DetailBigCarousel() {
    (0, _classCallCheck3.default)(this, DetailBigCarousel);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(DetailBigCarousel).call(this));
  }

  (0, _createClass3.default)(DetailBigCarousel, [{
    key: 'render',
    value: function render() {
      var styles = require('./DetailBigCarousel.scss');
      var data = this.props.data;
      var _props = this.props;
      var onClose = _props.onClose;
      var isOpened = _props.isOpened;

      var customStyle = {
        content: {
          position: 'absolute',
          top: '0px',
          left: '0px',
          right: '0px',
          bottom: '0px',
          border: '0px solid #ccc',
          background: '#fff',
          overflow: 'hidden',
          WebkitOverflowScrolling: 'touch',
          borderRadius: '0px',
          outline: 'none',
          padding: '0px'

        }
      };
      return _react2.default.createElement(
        _reactModal2.default,
        { style: customStyle, isOpen: isOpened },
        _react2.default.createElement(_ProductInfoFirstCarousel2.default, { images: data }),
        _react2.default.createElement(
          'span',
          { className: styles.backImg, onClick: onClose },
          _react2.default.createElement('img', {
            src: 'http://tupian.goeasy.cn:9999/yipinwang/third/jianshangpin_back.png', alt: '' })
        )
      );
    }
  }]);
  return DetailBigCarousel;
}(_react.Component), _class.propTypes = {
  isOpened: _react.PropTypes.bool,
  data: _react.PropTypes.array,
  onClose: _react.PropTypes.func
}, _temp);
exports.default = DetailBigCarousel;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/DetailBigCarousel/DetailBigCarousel.js
 ** module id = 1326
 ** module chunks = 0
 **/